<template>
    <div class="std-table-wrapper" v-if="isLoading == 0 && jewels.length > 0">
        <table class="certificate-jewel-table responsive">
            <thead class="">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Shape</th>
                    <th scope="col">Carat</th>
                    <th scope="col">Color</th>
                    <th scope="col">Clarity</th>
                    <th scope="col">Cut</th>
                    <th scope="col">Report Number</th>
                    <th scope="col">Edit</th>
                    <th scope="col">Remove</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(jewel, key, index) in jewels" v-bind:key="index">
                    <td>
                        <span class="col-title">No.</span
                        >{{ key + 1 + " of " + jewels.length }}
                    </td>
                    <td>
                        <span class="col-title">{{
                            jewelOptions.shape.label
                        }}</span
                        >{{ jewel.shape }}
                    </td>
                    <td>
                        <span class="col-title">{{
                            jewelOptions.carat.label
                        }}</span
                        >{{ jewel.carat }}
                    </td>
                    <td>
                        <span class="col-title">{{
                            jewelOptions.color.label
                        }}</span
                        >{{ jewelOptions.color.options[jewel.color]["title"] }}
                    </td>
                    <td>
                        <span class="col-title">{{
                            jewelOptions.clarity.label
                        }}</span
                        >{{
                            jewelOptions.clarity.options[jewel.clarity]["title"]
                        }}
                    </td>
                    <td>
                        <span class="col-title">{{
                            jewelOptions.shape.label
                        }}</span
                        >{{ jewelOptions.shape.options[jewel.shape]["title"] }}
                    </td>
                    <td>
                        <span class="col-title">{{
                            jewelOptions.lab_report_number.label
                        }}</span
                        >{{ jewel.lab_report_number }}
                    </td>
                    <td>
                        <div
                            class="btn tertiary btn-update"
                            v-on:click="editJewel(key)"
                        >
                            Edit
                        </div>
                    </td>
                    <td>
                        <div
                            class="btn tertiary btn-destroy"
                            v-on:click="removeJewel(key)"
                        >
                            Remove
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <span v-for="(jewel, key) in jewels">
            <input
                v-for="(value, name) in jewel"
                type="hidden"
                :name="'jewels[' + key + '][' + name + ']'"
                :value="value"
            />
        </span>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: {
        initial: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data: function () {
        return {
            jewels: this.initial,
            isLoading: 1,
        };
    },
    mounted() {
        this.getJewelOptions();
        this.$EventBus.$emit("jewel-count", {
            count: this.jewels.length,
        });

        this.$EventBus.$on("jewel-add", (data) => {
            if (data.key === false) {
                this.jewels.push(data.jewel);
            } else {
                this.jewels[data.key] = data.jewel;
            }
            this.$EventBus.$emit("jewel-count", {
                count: this.jewels.length,
            });
        });
    },
    methods: {
        getJewelOptions() {
            this.isLoading = 1;

            return this.$store.dispatch("fetchJewelOptions", []).then((res) => {
                this.isLoading = 0;
            });
        },
        editJewel: function (index) {
            //load the modal & pass the jewel data in
            let jewel = this.jewels[index];
            //console.log(index);
            this.$modal.show("add-jewel-modal", {
                data: { editJewel: jewel, key: index },
            });
        },
        removeJewel: function (key) {
            this.$delete(this.jewels, key);
            this.$EventBus.$emit("jewel-count", {
                count: this.jewels.length,
            });
        },
    },
    computed: {
        ...mapGetters(["jewelOptions"]),
    },
};
</script>

<style></style>
